/**
 * Accordion module
 *
 * @namespace APP
 * @name APP.Accordion
 */

APP.Accordion = (/** @lends APP.Accordion */function () {
	'use strict';

	var exports,
		initialized = false,
		$body,

	// Classes used in the HTML
		MOBILE_ONLY_CLASS = 'accordion--mobile-only',
		CLOSED_CLASS = 'accordion--closed';

	/**
	 * Init performance helpers
	 *
	 * @inner
	 * @public
	 * @memberof APP.Accordion
	 * @throws {ReferenceError} throws error if one of the methods fails
	 * @returns {void}
	 */
	function init() {
		if(initialized) {
			return;
		}

		initialized = true;
		initDOMElements();
		initBindings();
	}

	/**
	 * Init, cache DOM elements
	 *
	 * @inner
	 * @public
	 * @memberof APP.Accordion
	 * @returns {void}
	 */
	function initDOMElements() {
		$body = APP.Performance.getCachedDOM().$body;
	}

	/**
	 * Initialize event bindings<br>
	 *
	 * @inner
	 * @memberof APP.Accordion
	 * @returns {void}
	 */
	function initBindings() {

		$body.on({
			click: function (e) {
				e.preventDefault();
				toggleAccordion($(this));
			}
		}, '[data-accordion] [data-accordion-header]');

		$('[data-accordion-select]').on('change', function() {
			var val = $(this).val(),
				$target = $body.find('[data-accordion-header][data-accordion-target="' + val + '"]'),
				$accordionWrapper = $(this).parents('[data-accordion]').first();

			if(val !== '') {
				toggleAccordion($target);
			} else {
				$accordionWrapper.find('[data-accordion-header]').addClass(CLOSED_CLASS);
				$accordionWrapper.find('[data-accordion-body]').addClass(CLOSED_CLASS);
			}
		});

	}

	/**
	 * Toggle accordion
	 * Either the accordion is a single opened version or multiple opened
	 * You can set it with the 'data-accordion-type' attribute, possible values
	 * are:
	 * - 'single-open'
	 * - 'multiple-open'
	 *
	 * If the accordion is in mobile-only mode, than the accordion functionality
	 * won't work above 480px window width
	 *
	 * @param {jQuery} $elm the trigger element, usually the header part of the accordion
	 * @returns {Boolean|void} false or no return value
	 */
	function toggleAccordion($elm) {
		var $header = $elm,
			targetId = $header.attr('data-accordion-target') || false,
			$accordionWrapper = $elm.parents('[data-accordion]').first(),
			$accordionSelect = $accordionWrapper.find('[data-accordion-select]'),
			multipleOpen = $accordionWrapper.attr('data-accordion-type') === 'multiple-open',
			state,
			$target,
			selectValue;


		if (targetId !== false) {
			$target = $body.find('[data-accordion-id="' + targetId + '"]');
		} else {
			$target = $header.siblings('[data-accordion-body]').first();
		}

		if ($accordionWrapper.hasClass(MOBILE_ONLY_CLASS) && APP.Performance.getDeviceProperties().window.width > 480) {
			return false;
		}

		if ($target.hasClass(CLOSED_CLASS)) {

			if (multipleOpen !== true) {
				$accordionWrapper.find('[data-accordion-header]').addClass(CLOSED_CLASS);
				$accordionWrapper.find('[data-accordion-body]').addClass(CLOSED_CLASS);
			}

			$header.removeClass(CLOSED_CLASS);
			$target.removeClass(CLOSED_CLASS);
			state = 'opened';
		} else {
			$header.addClass(CLOSED_CLASS);
			$target.addClass(CLOSED_CLASS);
			state = 'closed';
		}

		if($accordionSelect.length && !multipleOpen) {
			selectValue = targetId;

			if(state === 'closed') {
				selectValue = '';
			}

			$accordionSelect.val(selectValue);
		}

		setState($target, state);
	}

	/**
	 * Set internal state of the accordion
	 *
	 * @param {jQuery} $target the target accordion part
	 * @param {Object} state the internal state of the accordion (opened or closed)
	 * @returns {void}
	 */
	function setState($target, state) {
		var accordionState;

		accordionState = $target.data('accordionState');

		if (accordionState === undefined) {
			accordionState = {};
		}

		accordionState.state = state;

		$target.data('accordionState', accordionState);
	}

	exports = {
		init: init
	};

	/* test-code */
	/* eslint no-underscore-dangle: 0 */
	exports.__testonly__ = {};
	/* end-test-code */

	return exports;

}());
